
import { defineComponent , inject } from 'vue'
import store, {ActionTypes} from '../../store'
import {mapState, mapGetters, mapActions} from 'vuex'
import { Notyf } from 'notyf';
import axios from 'axios';

const notyf = new Notyf();

export default defineComponent( {
  name : 'Dashboard' ,
  setup() {

  } ,
  computed : {
    ... mapState( [
      'user'
    ] ) ,
    ... mapGetters( [
      'isStaff'
    ] ) ,

  } ,

  data() {
    return {
      isLoading : true ,
      events : [] ,
      user : this.user
    }
  } ,
  created() {
    if ( store.getters.currentUser ) {
      const user = inject( 'user' , store.getters.currentUser )
      return {
        user ,
      }
    }
  } ,
  mounted() {
    this.fetchNotifications_all();
  },
  methods: {
    ...mapActions({
      fetchNotifications: ActionTypes.FETCH_NOTIFICATIONS // Mapping Vuex actions
    }),

    async fetchNotifications_all() {
      try {
        const response = await this.fetchNotifications();
        this.showNotifications(response);
      } catch (error) {
        console.error('Error fetching notifications:', error);
        notyf.error('Failed to fetch notifications');
      }
    },
    showNotifications(notifications:any) {
      notifications.forEach((notification:any) => {
        notyf.success(notification.message);
      });
    }
  }
} )
